import React, { Component } from 'react';
import { connect } from 'react-redux';
import { openModal } from 'actions/modalActions';
import { NavLink } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import img from 'static/tickmarkLogoSmall.svg';
import packageJson from '../../package.json';

class Main extends Component {
  render() {
    return (
      <div className="main">
        <img
          src={img}
          alt="Tickmark logo"
          style={{
            height: '2em',
            verticalAlign: 'top',
            marginRight: '0.6em',
            marginTop: 16,
          }}
        />
        <NavLink exact to="/" className="btn" activeClassName="active">
          TRT {packageJson.version}
        </NavLink>
        <NavLink to="/groups" className="btn" activeClassName="active">
          Groups
        </NavLink>
        <NavLink to="/accounts" className="btn" activeClassName="active">
          Accounts
        </NavLink>
        <NavLink to="/groupsaccounts" className="btn" activeClassName="active">
          Groups&Accounts
        </NavLink>
        <NavLink to="/journals" className="btn" activeClassName="active">
          Journals
        </NavLink>
        <NavLink to="/kpis" className="btn" activeClassName="active">
          KPIs
        </NavLink>
        <span className="separator"></span>
        <NavLink to="/settings" className="btn" activeClassName="active">
          Settings
        </NavLink>
        <button
          className="btn"
          onClick={() =>
            this.props.openModal({
              id: uuid(),
              type: 'component',
              componentType: 'HelpModal',
            })
          }
        >
          Help
        </button>
        <button
          className="btn"
          onClick={() =>
            this.props.openModal({
              id: uuid(),
              type: 'component',
              componentType: 'AboutModal',
            })
          }
        >
          About
        </button>
      </div>
    );
  }
}

export default connect(null, { openModal })(Main);
